import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-contracting.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Docflo";

const Docflo = () => (
  <div className="my-10">
    <div className="bg-navy pt-20 pb-10 transform -skew-y-6">
      <HeroSection title={title} className="text-white skew-y-6 flex-col-reverse md:flex-row">
        <HeroSection.Content className="w-full mb-10 md:pl-6 md:w-1/2 md:mb-20">
          <HeroSection.Header className="md:items-start lg:justify-start">
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>
          <HeroSection.Description className="text-gray-300">
            Docflo is docsigning, reimagined. Purpose-built for solar, Docflo intelligently serves up the right docs at
            the right time, with tons of useful features baked right in. You’ll never want to sign on another platform
            again.
          </HeroSection.Description>

          <HeroSection.Action className="btn-white" href="/features/docflo">
            Save Time with Intelligent Contracting
          </HeroSection.Action>
        </HeroSection.Content>

        <figure className="flex-grow p-3 md:pl-6 w-full xs:w-3/4 sm:w-3/5 md:w-1/2">
          <div className="pl-6 md:pl-0">
            <Image
              src={FigureImage}
              alt="Enerflo Solar Software Platform Docflo Doc Signing."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
      </HeroSection>
    </div>
  </div>
);

export default Docflo;
